/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-用户管理-用户信息
 */
'use strict';
angular.module("userInformationModule", ['userInformationServiceModule']).
controller('userInformationCtrl', ['$scope', 'userInformationService','httpService','$filter','modalDialog','trsspliceString','$q', function($scope, userInformationService,httpService,$filter,modalDialog,trsspliceString,$q) {
    initStatus();
    initData();
    
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            inputData: '',
            channelsOptions:[],
        };
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 20,
            "ITEMCOUNT": 0
        };
        $scope.data = {
            listData: [],
            keywords: "", //检索的关键词
            selectedArray: [], //选中的数据
        };
        $scope.pageCountJsons = [{ "name": "10", "value": 10 }, { "name": "25", "value": 25 }, { "name": "50", "value": 50 }];
    };

    function initData() {
    	initChannelsList().then(function(){
    		initDropDownList();
    		requestData();
    	})
    };
    
    /**
     * [initDropDownList description] 初始化下拉菜单
     * @return {[type]} [description]
     */
    function initDropDownList() {
        $scope.status.statusOptions = [{
            name: "全部状态",
            value: ''
        }, {
            name: "正常",
            value: 0
        }, {
            name: "停用",
            value: 1,
        }];
        $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
        $scope.status.typeOptions = [{
            name: "全部类型",
            value: ''
        }, {
            name: '前台',
            value: 0
        }, {
            name: '后台',
            value: 1
        }];
        $scope.status.selectedTypeStatus = angular.copy($scope.status.typeOptions[0]);
    };
    /**
     * [initChannelsList description] 初始化渠道
     * @return {[type]} [description]
     */
    function initChannelsList() {
        var deferred = $q.defer();
        httpService.http("/mcnadmin/admin/auth/getAuthChannels.do", "", "post").then(function(data) {
        	var item = data.data;
            var allchannel = {
                name: "全部渠道",
                value: ''
            }
            $scope.status.channelsOptions.push(allchannel);
            for (var i = 0; i < item.length; i++) {
                var creatJSON = {};
                creatJSON.name = item[i].channelName;
                creatJSON.value = item[i].id;
                $scope.status.channelsOptions.push(creatJSON);
            }
            $scope.status.selectedchannels = angular.copy($scope.status.channelsOptions[0]);
            deferred.resolve(data);
        })
        return deferred.promise;
    }
    /**
     * [createUser description] -新建用户
     * @return {[type]} [description]
     */
    $scope.createUser = function(isCreate,userId) {
        userInformationService.createUser(isCreate,userId).then(function(data) {
            $scope.loadingPromise = httpService.http("/mcnadmin/admin/ugcuser/addEdit.do", data, "post").then(function(data) {
            	var txt = "";
            	isCreate ? txt="新建用户成功" :txt="编辑用户成功";
            	modalDialog.alertType('',txt,'success');
				requestData();
            });
        });
    };
    /**
     * [roleSetting description] -角色设置
     * @return {[type]} [description]
     */
    $scope.roleSetting = function(userId) {
        userInformationService.roleSetting(userId).then(function(data) {
        	var params = {
        		roleIds:data,
				userId:userId
        	}
        	$scope.loadingPromise = httpService.http("/mcnadmin/admin/role/addUserRoles.do", params, "post").then(function(data) {
				modalDialog.alertType('','添加角色成功','success');
            });
        });
    };
    /**
     * [userDetails description] -用户详细信息
     * @return {[type]} [description]
     */
    $scope.userDetails = function(userId) {
        userInformationService.userDetails(userId).then(function(data) {});
    };
    
    /**
     * [fullTextSearch description;全文检索]
     * @param  {[type]} ev [description:按下回车也能提交]
     */
    $scope.fullTextSearch = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            requestData();
        }
    };
    
    /**
     * [deleteUsers description] -删除用户
     * @return {[type]} [description]
     */
    $scope.deleteUsers = function() {
        modalDialog.backConfirmModal("删除用户", "确认删除当前选中的用户?", function() {
            var params = {
                userIDs: angular.packageIds($scope.data.selectedArray,",","userId")
            };
            httpService.http("/mcnadmin/admin/ugcuser/delete.do", params, "post").then(function(data) {
            	modalDialog.alertType("","删除成功","success")
                requestData();
            });
        });
    };
    /**
     * [closeUsers description] -停用用户
     * @return {[type]} [description]
     */
    $scope.closeUsers = function() {
        modalDialog.backConfirmModal("停用用户", "确认停用当前选中的用户?", function() {
            var params = {
            	userStatus:1,//修改状态（0：停用 1：启用）
                userIDs: angular.packageIds($scope.data.selectedArray,",","userId")
            };
            httpService.http("/mcnadmin/admin/ugcuser/updateUsersStatus.do", params, "post").then(function(data) {
            	modalDialog.alertType("","停用成功","success")
                requestData();
            });
        });
    };
    /**
     * [openUsers description] -启用用户
     * @return {[type]} [description]
     */
    $scope.openUsers = function() {
        modalDialog.backConfirmModal("启用用户", "确认启用当前选中的用户?", function() {
            var params = {
            	userStatus:0,//修改状态（0：停用 1：启用）
                userIDs: angular.packageIds($scope.data.selectedArray,",","userId")
            };
            httpService.http("/mcnadmin/admin/ugcuser/updateUsersStatus.do", params, "post").then(function(data) {
            	modalDialog.alertType("","启用成功","success")
                requestData();
            });
        });
    };

    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectUser = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
    /**
     * [createProduct description] 初始化数据
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };

    function requestData() {
    	var params = {
            userStatus:$scope.status.selectedStatus.value,
            startDate:$scope.status.startDate,
            endDate:$scope.status.endDate,
            userType:$scope.status.selectedTypeStatus.value,
            sFiledValue: $scope.data.keywords,
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        }
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/ugcuser/list.do",params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
            
            $scope.data.selectedArray = [];
        });
    };
    /**
     * [dateFormat description] 时间格式化
     * @return {[type]} [description]
     */
    $scope.dateFormat = function(item) {
        item.newTime = $filter("date")(item.crtime, "yyyy-MM-dd HH:mm:ss").toString();
    };
    $scope.importUser = function() {
        userInformationService.importUser().then(function() {
			requestData();
        });
    }
}]);
